export default {
      id: "trash-can-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#trash-can",
      toString: function () {
        return this.url;
      }
    }